<template>
  <div
    class="flex flex-col rounded-lg shadow-lg overflow-hidden mb-4"
    :id="panelItemId"
  >
    <div class="p-2 bg-white" :class="panelBodyClasses">
      <h4 class="text-lg font-medium text-gray-900">
        {{ offerRequest.headline }}
      </h4>
      <span class="text-gray-500">{{ offerRequest.description }}</span>
    </div>
    <div class="bg-white border-t text-sm">
      <div class="p-2">
        <div>
          <div>
            <span class="text-gray-900">{{ lang.labels.category }}: </span>
            <span class="">{{ offerRequest.category }}</span>
          </div>
          <div>
            <span class="text-gray-900">{{ lang.labels.manufacturer }}: </span>
            <span class="">{{ offerRequest.manufacturer }}</span>
          </div>
        </div>
        <div
          v-if="offerRequest.name !== '' || offerRequest.location !== ''"
          class="mt-2"
        >
          <div v-if="offerRequest.name !== ''">{{ offerRequest.name }}</div>
          <div v-if="offerRequest.location !== ''">
            {{ offerRequest.location }}
          </div>
        </div>
      </div>

      <div
        class="bg-yellow-50 py-2 text-yellow-700 text-sm text-center"
        v-if="showLastContacted"
      >
        <span class="label label-warning">- {{ lastContactdMsg }} -</span>
      </div>

      <div class="">
        <plain-button @click="sendMsg" :disabled="contacted">
          {{ lang.labels.contact_offer_request_user }}
        </plain-button>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import PlainButton from "../buttons/PlainButton.vue";

const props = defineProps({
  guest: Boolean,
  offerRequest: Object,
  activeOfferRequest: Number,
  index: Number,
  lang: Object,
  contacted: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["show-register-modal", "send-msg"]);

const hightlightActiveOfferRequest = ref(true);

const panelItemId = computed(() => {
  return `item${props.offerRequest.id}`;
});

const panelBodyClasses = computed(() => {
  return {
    hightlightPanel:
      props.offerRequest.id === props.activeOfferRequest &&
      hightlightActiveOfferRequest.value === true,
  };
});

const showLastContacted = computed(() => {
  return props.contacted || props.offerRequest.contactedAt !== "";
});

const lastContactdMsg = computed(() => {
  let text = props.lang.pages.offer_request.listPublic.contact_label;

  if (props.contacted) {
    text = text.replace(":contactedAt", moment().format("DD.MM.YYYY"));
  } else {
    text = text.replace(":contactedAt", props.offerRequest.contactedAt);
  }

  return text;
});

const fadeOutHighlightedOfferRequest = () => {
  setTimeout(() => {
    hightlightActiveOfferRequest.value = false;
  }, 3200);
};

const sendMsg = () => {
  if (props.guest) {
    emit("show-register-modal");
    return;
  }

  emit("send-msg", props.offerRequest);
};

onMounted(() => {
  if (props.offerRequest.id === props.activeOfferRequest) {
    fadeOutHighlightedOfferRequest();
  }
});
</script>

<style scoped>
/* Scoped Styles */
.panel-body {
  background-color: #fff;
  transition: background-color 2s;
}

.hightlightPanel {
  background-color: #96c14c;
}
</style>
